import React, { Component } from 'react';
import {Container, Row, Col, Card, CardTitle, CardBody, CardFooter, Button, Input, InputGroup} from 'reactstrap';
import { app } from '../../base'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Form extends Component {
  constructor() {
    super();
    let uid = sessionStorage.getItem("uid");
    let user_type = sessionStorage.getItem("user_type");
    this.shop_id = '';
    this.state = {
      options_category: [],
      options_product: [],
      options_shop: [],
      message: '',
      shop_id: '',
      show: 'none',
      uid: uid,
      user_type: user_type
    }
    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onShopChange = this.onShopChange.bind(this);
  }

  componentDidMount() {
    this.createCategoryOptions();
    this.createProductOptions();
    if (this.state.user_type == 1) {
      this.createShopOptions();
    }
  }

  createCategoryOptions() {
    app.database().ref('/categories').orderByChild('name').once('value', (snapshot)=>{
      let options = [];
      snapshot.forEach((child)=>{
        options.push(<option key={child.key} value={child.key}>{child.val().name}</option>);
      });
      this.setState({
        options_category: options
      });
    });
  }

  createOption(products) {
    let options = [];
    for (let i = 0, len = products.length; i < len; i++) {
      options.push(<option key={products[i].key} value={products[i].key}>{products[i].val().name}</option>);
    }
    this.setState({
      options_product: options
    });
  }

  createProductOptions() {
    let inventory = [], products = [], user_type = this.state.user_type;
    if (user_type != 1) {
      this.shop_id = this.state.uid;
    }

    if (this.shop_id != '') {
      app.database().ref('inventory/'+this.shop_id).once('value', (snapshot)=>{
        snapshot.forEach((child)=>{
          inventory.push(child.key);
        });
      }).then(()=>{
        app.database().ref('/products').orderByChild('name').once('value', (snapshot)=>{
          snapshot.forEach((child)=>{
            if ((inventory.indexOf(child.key) == -1) && (child.val().status == 1)) {
              products.push(child);
            }
          });
          this.setState({
            products: products
          });
        }).then(()=>{
          this.createOption(products);
        });
      });
    }
    else {
      this.createOption(products);
    }
  }

  createShopOptions() {
    let result = [];
    app.database().ref('/users').orderByChild('user_type').equalTo(2).once('value', (snapshot)=>{
      snapshot.forEach((child)=>{
        if ((child.val().user_name != '') && (child.val().shop_name !== undefined)) {
          let data = {};
          data.key = child.key;
          data.user_name = child.val().user_name;
          data.shop_name = child.val().shop_name;
          result.push(data);
        }
      });
    })
    .then(()=>{
      let options = [];
      result.sort(function(a,b) {return (a.user_name > b.user_name) ? 1 : ((b.user_name > a.user_name) ? -1 : 0);});
      for (let i = 0, len = result.length; i < len; i++) {
        options.push(<option key={result[i].key} value={result[i].key}>{result[i].user_name+' ('+result[i].shop_name+')'}</option>);
      }
      this.setState({
        options_shop: options
      });
    });
  }

  formSubmit(event) {
    event.preventDefault();

    let shop_id;
    if (this.state.user_type == 1) {
      shop_id = this.shopInput.value;
    }
    else {
      shop_id = this.state.uid;
    }
    
    const product_id = this.productInput.value
    const price = this.priceInput.value

    if (shop_id == '' || product_id == '' || price == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    app.database().ref('inventory/'+shop_id+'/'+product_id).set({
      price: price,
      status: 1
    });
    this.setMessage('Inventory updated');
    this.createProductOptions();
    this.entryForm.reset()
  }

  onCategoryChange(event) {
    let products = this.state.products;
    let updated_list = [];
    if (event.target.value == '') {
      updated_list = products;
    }
    else {
      for (let i = 0; i < products.length; i++) {
        if (products[i].val().category_id == event.target.value) {
          updated_list.push(products[i]);
        }
      }
    }

    this.createOption(updated_list);
  }

  onShopChange(event) {
    this.shop_id = event.target.value;
    this.createProductOptions();
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <ShowMessage show={this.state.show} message={this.state.message} />
                  <form onSubmit={(event) => { this.formSubmit(event) }} ref={(form) => { this.entryForm = form }}>
                    {(this.state.user_type == 1) && 
                      <InputGroup className="mb-3">
                        <Input type="select" name="shop_list" innerRef={(input) => { this.shopInput = input }} onChange={this.onShopChange} required>
                          <option value="">Select Shop</option>
                          {this.state.options_shop}
                        </Input>
                      </InputGroup>
                    }
                    <InputGroup className="mb-3">
                      <Input type="select" name="category" innerRef={(input) => { this.categoryInput = input }} onChange={this.onCategoryChange}>
                        <option value="">Select Category</option>
                        {this.state.options_category}
                      </Input>
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <Input type="select" name="brands" innerRef={(input) => { this.productInput = input }} required>
                          <option value="">Select Product</option>
                          {this.state.options_product}
                        </Input>
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="Product Price" innerRef={(input) => { this.priceInput = input }} defaultValue={this.state.product_price} required />
                      </InputGroup>
                    <Button color="success" block>Add to Inventory</Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/views/Inventory/Form.js